// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3669":"e72d9e4c","3928":"3275bc4f"}[chunkId] + ".chunk.css";
};